import React from 'react';
import { ListGroup } from 'react-bootstrap';

const ListItem = ({ 
    children, 
    action = false, 
    active = false, 
    disabled = false, 
    variant,
    onClick,
    href,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <ListGroup.Item 
            action={action}
            active={active}
            disabled={disabled}
            variant={variant}
            onClick={onClick}
            href={href}
            className={className} 
            style={style}
            {...props}
        >
            {children}
        </ListGroup.Item>
    );
};

export default ListItem;

